import { createContext } from 'react'

const ProcessContext = createContext();
export default ProcessContext;